import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'smart-tools.minimum-spots.class-level-flyout.title',
    defaultMessage: 'Always ensure there are a certain amount of spots bookable to ClassPass members.',
  },
  description: {
    id: 'smart-tools.minimum-spots.class-level-flyout.description',
    defaultMessage:
      'Set the starting allocation for individual classes. These will override your venue-level peak/off-peak settings.',
  },
  className: {
    id: 'smart-tools.minimum-spots.class-level-flyout.class-name',
    defaultMessage: 'Class name',
  },
  peak: {
    id: 'smart-tools.minimum-spots.class-level-flyout.peak',
    defaultMessage: 'Peak',
  },
  offPeak: {
    id: 'smart-tools.minimum-spots.class-level-flyout.off-peak',
    defaultMessage: 'Off-peak',
  },
  cancel: {
    id: 'smart-tools.minimum-spots.class-level-flyout.cancel',
    defaultMessage: 'Cancel',
  },
  save: {
    id: 'smart-tools.minimum-spots.class-level-flyout.save',
    defaultMessage: 'Save',
  },
  errorClassData: {
    id: 'smart-tools.minimum-spots.class-level-flyout.error',
    defaultMessage: 'There was an error loading your class data.',
  },
  errorTryAgain: {
    id: 'smart-tools.minimum-spots.class-level-flyout.error-try-again',
    defaultMessage: 'Try again',
  },
  noClassesFound: {
    id: 'smart-tools.minimum-spots.class-level-flyout.no-classes-found',
    defaultMessage: 'No classes found.',
  },
  successSave: {
    id: 'smart-tools.minimum-spots.class-level-flyout.success-save',
    defaultMessage: 'Class settings saved successfully',
  },
  errorSave: {
    id: 'smart-tools.minimum-spots.class-level-flyout.error-save',
    defaultMessage: 'Failed to save class settings. Please try again.',
  },
  venueLevelInfo: {
    id: 'smart-tools.minimum-spots.class-level-flyout.venue-level-info',
    defaultMessage: 'By selecting Venue-level your class will be set to the Venue-level allocation.',
  },
});
